<template>
  <div>
    <vs-tabs>
      <vs-tab label="Пропуска">
        <vs-row class="mt-1 mb-1 justify-center">
          <div class="-mx-3 flex flex-wrap items-stretch">
            <div class="px-3 mb-2 md:w-3/12 w-full">
              <vs-button
                @click="openCreateModal('one-time')"
                class="w-full h-full"
                color="primary"
                type="border"
                >Разовый пропуск (авто)</vs-button
              >
            </div>
            <div class="px-3 mb-2 md:w-3/12 w-full">
              <vs-button
                @click="openCreateModal('tech')"
                class="w-full h-full"
                color="primary"
                type="border"
                >Многоразовый пропуск</vs-button
              >
            </div>
            <div class="px-3 mb-2 md:w-3/12 w-full">
              <vs-button
                @click="openCreateModal('permanent')"
                class="w-full h-full"
                color="primary"
                type="border"
                >Постоянный пропуск на авто (владелец)</vs-button
              >
            </div>
            <div class="px-3 mb-2 md:w-3/12 w-full">
              <vs-button
                @click="openCreateModal('tech_personal')"
                class="w-full h-full"
                color="primary"
                type="border"
                >Пропуск на технический персонал без авто</vs-button
              >
            </div>
          </div>
        </vs-row>

        <vx-card
          title="Фильтры"
          class="p-1 mb-3 passes__filter-card"
          style="background: #e3e6fd"
          collapseAction
          :isContentCollapsed="true"
        >
          <div class="flex flex-wrap items-center justify-start w-full">
            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                @input="getAllPasses()"
                :options="countItemsOmPage"
                :clearable="false"
                v-model="countElements"
                style="background-color: #fff"
                placeholder="Количество пропусков"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>
            <div
              class="header-filter md:w-2/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                placeholder="Тип пропуска"
                @input="filterPasses"
                label="name"
                :options="passType"
                :reduce="(name) => name.id"
                :clearable="true"
                v-model="filter.kind"
                style="background-color: #fff"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <vs-input
                class="w-full"
                placeholder="Номер участка"
                v-model="filter.home__homestead_number__iexact"
              />
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <vs-input
                class="w-full"
                placeholder="ФИО"
                v-model="filter.full_name__icontains"
              />
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <vs-input
                class="w-full"
                placeholder="Номер ТС"
                v-model="filter.car_number__icontains"
              />
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                @input="filterPasses"
                label="name"
                :options="countyType"
                :reduce="(name) => name.id"
                :clearable="false"
                v-model="filter.home__county_type"
                placeholder="Выбор поселения"
                style="background-color: #fff"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                @input="filterPasses"
                label="name"
                :options="carType"
                :reduce="(name) => name.id"
                :clearable="false"
                v-model="filter.car_type"
                placeholder="Тип авто"
                style="background-color: #fff"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                @input="filterPasses"
                label="name"
                :options="passStatusType"
                :reduce="(name) => name.id"
                :clearable="true"
                v-model="filter.is_used"
                placeholder="Статус"
                style="background-color: #fff"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>
            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <flat-pickr
                class="block w-full"
                :config="configdateTimePickerFilter"
                placeholder="Дата начала для экспорта"
                v-model="exportDates.date_start"
              />
            </div>
            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <flat-pickr
                class="block w-full"
                :config="configdateTimePickerFilter"
                placeholder="Дата конца для экспорта"
                v-model="exportDates.date_end"
              />
            </div>

            <div
              class="
                header-filter
                md:w-6/12
                w-full
                md:mb-3
                mb-2
                md:px-2
                cursor-pointer
              "
            >
              <vs-button
                @click="resetFilter"
                class="w-full"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-trash"
                >Очистить</vs-button
              >
            </div>

            <div
              class="
                header-filter
                md:w-6/12
                w-full
                md:mb-3
                mb-2
                md:px-2
                cursor-pointer
              "
            >
              <vs-button
                @click="elementsForExcel"
                class="w-full"
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-save"
                >Экспорт</vs-button
              >
            </div>
          </div>
        </vx-card>

        <vx-card title="Таблица пропусков" class="p-6">
          <vs-table
            :data="passes"
            :stripe="true"
            :search="false"
            :pagination="false"
            :maxItems="20"
            noDataText="Элементов не найдено"
          >
            <template slot="header">
              <div class="w-full flex justify-end">
                <div class="header-filter md:w-2/12 w-full mb-2 cursor-pointer">
                  <vs-input
                    class="w-full"
                    placeholder="Номер ТС"
                    v-model="filter.car_number__icontains"
                  />
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th> # </vs-th>
              <vs-th> Кто оформил заявку </vs-th>
              <vs-th> К кому </vs-th>
              <vs-th> Даты </vs-th>
              <vs-th> Подробнее </vs-th>
              <vs-th> Тип пропуска </vs-th>
              <vs-th> Статус </vs-th>
              <vs-th> Тип авто </vs-th>
              <vs-th> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                class="text-xl font-semibold"
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td>
                  {{ data[indextr].id }}
                </vs-td>

                <vs-td>
                  <p class="mb-2">
                    Оформил пропуск:
                    <span
                      v-if="data[indextr].user.is_security"
                      class="text-primary"
                      >Охрана</span
                    >
                    <span
                      v-else-if="data[indextr].user.is_staff"
                      class="text-primary"
                      >Администратор</span
                    >
                    <span v-else class="text-primary">{{
                      data[indextr].user.full_name
                    }}</span>
                  </p>
                </vs-td>

                <vs-td>
                  <p v-if="data[indextr].home" class="mb-3">
                    Поселок
                    {{
                      data[indextr].home.county_type.id == "forest"
                        ? "Гр. Лес"
                        : "Гр. Пруды"
                    }}
                  </p>
                  <p v-if="data[indextr].home" class="mb-3">
                    Участок #{{ data[indextr].home.homestead_number }}
                  </p>
                </vs-td>

                <vs-td>
                  <p v-if="data[indextr].date_booked !== null" class="mb-2">
                    Пропуск действует только
                    <span class="text-primary">{{
                      data[indextr].date_booked
                    }}</span>
                  </p>
                  <p v-else class="mb-2">
                    Пропуск действует <br />
                    с
                    <span class="text-primary">{{
                      data[indextr].date_booked_from
                    }}</span>
                    до
                    <span class="text-primary">{{
                      data[indextr].date_booked_to
                    }}</span>
                  </p>
                </vs-td>

                <vs-td>
                  <template v-if="data[indextr].kind.id !== 'tech_personal'">
                    <p v-if="data[indextr].car_type" class="mb-2">
                      Тип авто:
                      <span class="text-primary font-bold">{{
                        data[indextr].car_type.name
                      }}</span>
                    </p>
                    <p v-if="data[indextr].car" class="mb-2">
                      Марка:
                      <span class="text-primary font-bold">{{
                        data[indextr].car
                      }}</span>
                    </p>
                    <p v-if="data[indextr].car_number" class="mb-2">
                      Номер:
                      <span class="text-primary font-bold">{{
                        data[indextr].car_number
                      }}</span>
                    </p>
                  </template>

                  <p v-if="data[indextr].full_name" class="mb-2">
                    ФИО:
                    <span class="text-primary">{{
                      data[indextr].full_name
                    }}</span>
                  </p>
                  <p v-if="data[indextr].passenger_number" class="mb-2">
                    Количество пассажиров:
                    <span class="text-primary font-bold">{{
                      data[indextr].passenger_number
                    }}</span>
                  </p>
                  <p v-if="data[indextr].is_guest" class="mb-2">
                    На гостя:
                    <span class="text-primary font-bold">{{
                      data[indextr].is_guest ? "Да" : "Нет"
                    }}</span>
                  </p>
                  <p v-if="data[indextr].description" class="mb-2">
                    Примечание:
                    <span class="text-primary font-bold">{{
                      data[indextr].description
                    }}</span>
                  </p>
                </vs-td>

                <vs-td>
                  {{ data[indextr].kind.name }}
                </vs-td>

                <vs-td>
                  <template v-if="!data[indextr].is_used"
                    ><p class="text-success">Активен</p>
                  </template>
                  <template v-else
                    ><p class="text-danger">Не активен</p></template
                  >
                  <p v-if="data[indextr].kind.id !== 'one-time'">
                    Кол-во проездов: {{ data[indextr].passage_number }}
                  </p>
                </vs-td>

                <vs-td>
                  <ul
                    v-if="data[indextr].kind.id !== 'tech_personal'"
                    class="flex flex-wrap justify-center"
                  >
                    <li class="mb-2 mr-2">
                      <vx-tooltip class="inline-block" text="Гр.тр. до 1.5 т.">
                        <vs-button
                          size="small"
                          @click="fastUpdateCarType(data[indextr].id, '1.5')"
                          color="primary"
                          :class="
                            data[indextr].car_type.id == '1.5'
                              ? 'vs-button-filled'
                              : 'vs-button-border'
                          "
                          >1</vs-button
                        >
                      </vx-tooltip>
                    </li>
                    <li class="mb-2 mr-2">
                      <vx-tooltip class="inline-block" text="Гр.тр. до 3.5 т.">
                        <vs-button
                          size="small"
                          @click="fastUpdateCarType(data[indextr].id, '3.5')"
                          color="primary"
                          :class="
                            data[indextr].car_type.id == '3.5'
                              ? 'vs-button-filled'
                              : 'vs-button-border'
                          "
                          >2</vs-button
                        >
                      </vx-tooltip>
                    </li>
                    <li class="mb-2 mr-2">
                      <vx-tooltip class="inline-block" text="Гр.тр. до 5 т.">
                        <vs-button
                          size="small"
                          @click="fastUpdateCarType(data[indextr].id, '5')"
                          color="primary"
                          :class="
                            data[indextr].car_type.id == '5'
                              ? 'vs-button-filled'
                              : 'vs-button-border'
                          "
                          >3</vs-button
                        >
                      </vx-tooltip>
                    </li>
                    <li class="mb-2 mr-2">
                      <vx-tooltip class="inline-block" text="Фура/Спецтехника">
                        <vs-button
                          size="small"
                          @click="
                            fastUpdateCarType(data[indextr].id, 'heavy_lorry')
                          "
                          color="primary"
                          :class="
                            data[indextr].car_type.id == 'heavy_lorry'
                              ? 'vs-button-filled'
                              : 'vs-button-border'
                          "
                          >4</vs-button
                        >
                      </vx-tooltip>
                    </li>
                  </ul>
                </vs-td>

                <vs-td>
                  <div
                    v-if="
                      validateDate(
                        data[indextr].date_booked !== null
                          ? data[indextr].date_booked
                          : data[indextr].date_booked_from
                      )
                    "
                    class="mb-3"
                  >
                    <vs-button
                      @click="confirmEntryPass(data[indextr].id, 'entry')"
                      v-if="!data[indextr].is_used"
                      class="mb-2"
                      icon-pack="feather"
                      icon="icon-check"
                      type="filled"
                    >
                      <template v-if="data[indextr].kind.id == 'tech_personal'">
                        Прошел
                      </template>
                      <template v-else> Въехал </template>
                    </vs-button>
                  </div>
                  <vx-tooltip
                    v-if="
                      !(data[indextr].is_entered || data[indextr].is_exited)
                    "
                    class="inline-block"
                    text="Редактировать пропуск"
                  >
                    <vs-button
                      @click="openEdit(data[indextr].id)"
                      v-if="!data[indextr].is_used"
                      color="dark"
                      class="text-dark"
                      icon-pack="feather"
                      icon="icon-edit"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>

                  <vx-tooltip
                    class="inline-block"
                    text="Быстрый просмотр пропуска"
                  >
                    <vs-button
                      @click="getSimplePass(data[indextr].id)"
                      color="dark"
                      class="text-dark"
                      icon-pack="feather"
                      icon="icon-eye"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>

                  <vx-tooltip class="inline-block" text="Открыть пропуск">
                    <vs-button
                      :href="`/passes/${data[indextr].id}`"
                      color="dark"
                      class="text-dark"
                      icon-pack="feather"
                      icon="icon-external-link"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination
            class="mt-4"
            :total="totalPagePagination"
            v-model="currentPagingationPage"
          ></vs-pagination>
        </vx-card>
      </vs-tab>
      <vs-tab
        @click="getPassesTariffs"
        v-if="!$acl.not.check('admin')"
        label="Тарифы"
      >
        <vx-card v-if="tariffs.length" title="Тарифы" class="p-6">
          <vs-input
            @change="
              updateTariff(tariffs.find((x) => x.kind == 'passenger').id)
            "
            class="w-full mb-8"
            label-placeholder="Легковой, руб"
            v-model.number="tariffs.find((x) => x.kind == 'passenger').price"
          />
          <vs-input
            @change="updateTariff(tariffs.find((x) => x.kind == '1.5').id)"
            class="w-full mb-8"
            label-placeholder="Гр.тр. до 1.5 т."
            v-model.number="tariffs.find((x) => x.kind == '1.5').price"
          />
          <vs-input
            @change="updateTariff(tariffs.find((x) => x.kind == '3.5').id)"
            class="w-full mb-8"
            label-placeholder="Гр.тр. до 3.5 т."
            v-model.number="tariffs.find((x) => x.kind == '3.5').price"
          />
          <vs-input
            @change="updateTariff(tariffs.find((x) => x.kind == '5').id)"
            class="w-full mb-8"
            label-placeholder="Гр.тр. до 5 т."
            v-model.number="tariffs.find((x) => x.kind == '5').price"
          />
          <vs-input
            @change="
              updateTariff(tariffs.find((x) => x.kind == 'heavy_lorry').id)
            "
            class="w-full mb-8"
            label-placeholder="Фура/Спецтехника, руб"
            v-model.number="tariffs.find((x) => x.kind == 'heavy_lorry').price"
          />
        </vx-card>
      </vs-tab>
      <vs-tab @click="getInstructions" label="Инструкция">
        <vx-card
          v-if="!$acl.not.check('admin')"
          title="Инструкция"
          class="mb-6 p-6"
        >
          <quill-editor
            class="mb-4"
            v-model="instructons"
            :options="editorOption"
          />
          <vs-button @click="updateInstructions">Сохранить</vs-button>
        </vx-card>
        <vx-card title="Инструкция" class="mb-6 p-6">
          <div v-html="instructons"></div>
        </vx-card>
      </vs-tab>
    </vs-tabs>

    <vs-popup
      :title="`Создать ${newPass.kind.name}`"
      :active.sync="activeCreatePrompt"
      :button-close-hidden="true"
      v-on:close="clearNewPass"
    >
      <div class="loading-wrap vs-con-loading__container">
        <label class="block mb-2 vs-input--label">Поселок</label>
        <ul class="flex mb-3">
          <li class="mr-5">
            <vs-radio
              v-validate="'required'"
              name="Поселок"
              @input="changeCountyType"
              v-model="newPass.county_type"
              vs-value="pond"
              >Графские Пруды</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-validate="'required'"
              name="Поселок"
              @input="changeCountyType"
              v-model="newPass.county_type"
              vs-value="forest"
              >Графский Лес</vs-radio
            >
          </li>
        </ul>
        <span class="block text-danger text-sm">{{
          errors.first("Поселок")
        }}</span>

        <template v-if="newPass.kind.id !== 'tech_personal'">
          <label class="vs-input--label">Марка машины</label>
          <vue-autosuggest
            ref="autocomplete"
            v-model="newPass.car"
            :suggestions="suggestions"
            :input-props="inputProps"
            :get-suggestion-value="getSuggestionValueNewPass"
            @input="fetchResults('new')"
          />

          <vs-input
            class="w-full"
            v-validate="'required'"
            label="Номер машины"
            name="Номер машины"
            v-model="newPass.car_number"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Номер машины")
          }}</span>
        </template>

        <template v-if="newPass.county_type !== ''">
          <label class="vs-input--label">Участок</label>
          <v-select
            v-validate="'required'"
            name="Участок"
            label="name"
            :options="homesFilter"
            :reduce="(name) => name.id"
            :clearable="false"
            v-model="newPass.home"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
          <span class="block text-danger text-sm">{{
            errors.first("Участок")
          }}</span>
        </template>

        <template v-if="newPass.kind !== '' && newPass.kind.id !== 'one-time'">
          <label class="vs-input--label">Дата начала действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата начала действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="newPass.date_booked_from"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата начала действия пропуска")
          }}</span>

          <label class="vs-input--label">Дата конца действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата конца действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="newPass.date_booked_to"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата конца действия пропуска")
          }}</span>
        </template>
        <template
          v-else-if="newPass.kind !== '' && newPass.kind.id === 'one-time'"
        >
          <label class="vs-input--label">Дата действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="newPass.date_booked"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата действия пропуска")
          }}</span>
        </template>

        <template
          v-if="
            newPass.kind.id !== 'one-time' && newPass.kind.id !== 'permanent'
          "
        >
          <vs-input
            class="w-full mb-4"
            label="ФИО"
            name="ФИО"
            v-model="newPass.full_name"
          />
        </template>

        <template
          v-if="
            newPass.kind.id !== 'tech_personal' &&
            newPass.kind.id !== 'permanent'
          "
        >
          <label class="vs-input--label">Тип транспорта</label>
          <v-select
            name="Тип транспорта"
            label="name"
            :options="carType"
            :reduce="(name) => name.id"
            :clearable="false"
            v-model="newPass.car_type"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </template>

        <template
          v-if="
            newPass.kind.id !== 'tech_personal' &&
            newPass.kind.id !== 'permanent'
          "
        >
          <vs-input
            class="w-full mb-4"
            label="Количество пассажиров"
            name="Количество пассажиров"
            type="number"
            v-model.number="newPass.passenger_number"
          />
        </template>

        <vs-checkbox
          v-if="newPass.kind.id == 'one-time' || newPass.kind.id == 'tech'"
          class="mb-2"
          v-model="newPass.is_guest"
          >Гость</vs-checkbox
        >

        <vs-input
          class="w-full mb-4"
          label="Примечание"
          name="Примечание"
          v-model="newPass.description"
        />

        <div class="popup-footer mt-auto">
          <vs-button @click="createPass" class="mr-5" type="relief"
            >Создать</vs-button
          >
          <vs-button @click="clearNewPass" color="dark" type="border"
            >Отмена</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      v-if="updatedPass !== null"
      title="Редактировать пропуск"
      :active.sync="activeEditPrompt"
      :button-close-hidden="true"
    >
      <div class="loading-wrap vs-con-loading__container">
        <label class="block mb-2 vs-input--label">Поселок</label>
        <ul class="flex mb-3">
          <li class="mr-5">
            <vs-radio
              v-validate="'required'"
              name="Поселок"
              @input="changeCountyType"
              v-model="updatedPass.county_type"
              vs-value="pond"
              >Графские Пруды</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-validate="'required'"
              name="Поселок"
              @input="changeCountyType"
              v-model="updatedPass.county_type"
              vs-value="forest"
              >Графский Лес</vs-radio
            >
          </li>
        </ul>
        <span class="block text-danger text-sm">{{
          errors.first("Поселок")
        }}</span>

        <template v-if="updatedPass.kind.id !== 'tech_personal'">
          <label class="vs-input--label">Марка машины</label>
          <vue-autosuggest
            ref="autocomplete"
            v-model="updatedPass.car"
            :suggestions="suggestions"
            :input-props="inputProps"
            :get-suggestion-value="getSuggestionValueupdatedPass"
            @input="fetchResults('updated')"
          />

          <vs-input
            class="w-full"
            v-validate="'required'"
            label="Номер машины"
            name="Номер машины"
            v-model="updatedPass.car_number"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Номер машины")
          }}</span>
        </template>

        <template v-if="updatedPass.county_type !== ''">
          <label class="vs-input--label">Участок</label>
          <v-select
            v-validate="'required'"
            name="Участок"
            label="name"
            :options="homesFilter"
            :reduce="(name) => name.id"
            :clearable="false"
            v-model="updatedPass.home"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
          <span class="block text-danger text-sm">{{
            errors.first("Участок")
          }}</span>
        </template>

        <template
          v-if="updatedPass.kind !== '' && updatedPass.kind.id !== 'one-time'"
        >
          <label class="vs-input--label">Дата начала действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата начала действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="updatedPass.date_booked_from"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата начала действия пропуска")
          }}</span>

          <label class="vs-input--label">Дата конца действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата конца действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="updatedPass.date_booked_to"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата конца действия пропуска")
          }}</span>
        </template>
        <template
          v-else-if="
            updatedPass.kind !== '' && updatedPass.kind.id === 'one-time'
          "
        >
          <label class="vs-input--label">Дата действия пропуска</label>
          <flat-pickr
            v-validate="'required'"
            name="Дата действия пропуска"
            class="block w-full"
            :config="configdateTimePicker"
            v-model="updatedPass.date_booked"
          />
          <span class="block text-danger text-sm">{{
            errors.first("Дата действия пропуска")
          }}</span>
        </template>

        <template
          v-if="
            updatedPass.kind.id !== 'one-time' &&
            updatedPass.kind.id !== 'permanent'
          "
        >
          <vs-input
            class="w-full mb-4"
            label="ФИО"
            name="ФИО"
            v-model="updatedPass.full_name"
          />
        </template>

        <template
          v-if="
            updatedPass.kind.id !== 'tech_personal' &&
            updatedPass.kind.id !== 'permanent'
          "
        >
          <label class="vs-input--label">Тип транспорта</label>
          <v-select
            name="Тип транспорта"
            label="name"
            :options="carType"
            :clearable="false"
            v-model="updatedPass.car_type"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </template>

        <template
          v-if="
            updatedPass.kind.id !== 'tech_personal' &&
            updatedPass.kind.id !== 'permanent'
          "
        >
          <vs-input
            class="w-full mb-4"
            label="Количество пассажиров"
            name="Количество пассажиров"
            type="number"
            v-model.number="updatedPass.passenger_number"
          />
        </template>

        <vs-checkbox
          v-if="
            updatedPass.kind.id == 'one-time' || updatedPass.kind.id == 'tech'
          "
          class="mb-2"
          v-model="updatedPass.is_guest"
          >Гость</vs-checkbox
        >

        <vs-input
          class="w-full mb-4"
          label="Примечание"
          name="Примечание"
          v-model="updatedPass.description"
        />

        <div class="popup-footer mt-auto">
          <vs-button
            @click="updatePass"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            color="primary"
            >Обновить</vs-button
          >
          <vs-button
            @click="clearUpdatedPass"
            class="mr-5"
            color="dark"
            type="border"
            >Отмена</vs-button
          >
          <vs-button
            @click="deletePass(updatedPass.id)"
            class="mr-5"
            type="relief"
            color="danger"
            >Удалить</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      :title="`Просмотр пропуска #${idSimplePass}`"
      :active.sync="activeSimplePopup"
    >
      <simple-pass-modal :idPass="idSimplePass"></simple-pass-modal>
    </vs-popup>
  </div>
</template>
 
<script>
import {
  API_URL,
  passType,
  carType,
  countyType,
  passStatusType,
  countItemsOmPage,
  DaDataToken,
} from "@/.env";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { DateTime } from "luxon";

import { VueAutosuggest } from "vue-autosuggest";
import axios from "axios";

import SimplePassModal from "./components/SimplePassModal";

export default {
  data: () => ({
    suggestions: [],
    timeout: null,
    inputProps: {
      class: "vs-inputx vs-input--input normal form-control",
      id: "autosuggest__input",
    },

    passes: [],
    idSimplePass: 0,
    activeSimplePopup: false,
    activeCreatePrompt: false,
    activeEditPrompt: false,
    idUpdatePass: null,
    updatedPass: null,
    newPass: {
      home: "",
      full_name: "",
      date_booked: "",
      date_booked_to: "",
      date_booked_from: "",
      car_number: "",
      car: "",
      car_type: "",
      kind: "",
      county_type: "",
      passenger_number: 0,
      description: "",
      is_guest: false,
    },
    filter: {
      kind: "",
      home__county_type: "all",
      car_number__icontains: "",
      home__homestead_number__iexact: "",
      is_used: "false",
      car_type: "all",
      full_name__icontains: "",
    },
    tariffs: [],
    instructons: "",
    editorOption: {
      placeholder: "Введите текст",
    },

    BASE_URL: API_URL,
    DaDataToken,
    carType: [{ id: "all", name: "Все авто" }, ...carType],
    passType,
    countyType: [{ id: "all", name: "Все поселения" }, ...countyType],
    passStatusType,

    countElements: 20,

    currentPagingationPage: 1,
    totalPasses: 0,
    totalPagePagination: 1,
    countItemsOmPage: countItemsOmPage,

    homes: [],
    homesFilter: [],

    configdateTimePicker: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
      minDate: "today",
    },

    exportDates: {
      date_start: "",
      date_end: "",
    },
    configdateTimePickerFilter: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
    },

    excelData: [],
  }),
  components: {
    flatPickr,
    quillEditor,
    DateTime,
    VueAutosuggest,
    SimplePassModal,
  },
  watch: {
    "newPass.kind": function (old, newval) {
      if (old.id !== "one-time") {
        this.newPass.date_booked = "";
      } else {
        this.newPass.date_booked_to = "";
        this.newPass.date_booked_from = "";
      }
    },
    filter: {
      handler(val) {
        this.filterPasses();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
    },
    currentPagingationPage: function () {
      this.getAllPasses();
    },
  },
  computed: {},
  methods: {
    validateDate(date) {
      try {
        let nowDate = DateTime.local().toISODate();
        let formatDate = DateTime.fromFormat(date, "dd.MM.yyyy").toISODate();
        return formatDate <= nowDate;
      } catch (error) {}
    },
    getSuggestionValueNewPass(suggestion) {
      this.newPass.car = suggestion.item;
    },
    getSuggestionValueEditPass(suggestion) {
      this.updatedPass.car = suggestion.item;
    },
    fetchResults(type) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const carPromise = axios
          .post(
            "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/car_brand",
            {
              query: type === "new" ? this.newPass.car : this.updatedPass.car,
            },
            {
              headers: {
                Authorization: `Token ${DaDataToken}`,
              },
            }
          )
          .then((result) => {
            let arr = [];
            result.data.suggestions.forEach((element) => {
              arr.push(element.value);
            });

            this.suggestions = [
              {
                data: arr,
              },
            ];
          });
      }, 500);
    },

    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterPasses: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getAllPasses();
    }, 1500),
    confirmEntryPass(id) {
      this.confirmPass(id, "entry");
    },
    openEdit(id) {
      let updatedPass = JSON.parse(
        JSON.stringify(this.passes.find((x) => x.id == id))
      );

      if (updatedPass.is_hidden) {
        this.notification(
          "Ошибка",
          "Пропуск нельзя обновить, т.к. он удален в приложении",
          "warning"
        );
      } else {
        updatedPass.home = {
          id: updatedPass.home.id,
          county_type: updatedPass.home.county_type,
          name: `${updatedPass.home.homestead_number}`,
        };

        this.updatedPass = updatedPass;

        if (this.homes.length == 0) {
          this.getAllHomes();
        }

        this.activeEditPrompt = true;
      }
    },
    confirmPass(idPass, type) {
      let payload = {
        id: idPass,
        kind: type,
      };

      this.$load(async () => {
        let res = (await this.$api.passes.updateStatusPass(payload)).data;

        if (res) {
          this.notification(
            "Успешно",
            "Статус пропуска обновился. Время зафиксировано.",
            "success"
          );

          let pass = this.passes.find((x) => x.id == idPass),
            index = this.passes.indexOf(pass),
            passType = pass.kind.id;

          pass.passage_number++;

          if (passType == "one-time" && index !== -1) {
            this.passes.splice(index, 1);
          }
        } else {
          this.notification(
            "Ошибка",
            "Не удалось обновить статус пропуска",
            "danger"
          );
        }
      });
    },
    createPass() {
      try {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$vs.loading();
            let payload = JSON.parse(JSON.stringify(this.newPass));

            Object.keys(payload).forEach(
              (k) =>
                !payload[k] && payload[k] !== undefined && delete payload[k]
            );

            payload.kind = payload.kind.id;

            if (payload.date_booked) {
              payload.date_booked = DateTime.fromFormat(
                payload.date_booked,
                "dd.MM.yyyy"
              ).toISODate();
            }

            if (payload.date_booked_to) {
              payload.date_booked_to = DateTime.fromFormat(
                payload.date_booked_to,
                "dd.MM.yyyy"
              ).toISODate();
            }

            if (payload.date_booked_from) {
              payload.date_booked_from = DateTime.fromFormat(
                payload.date_booked_from,
                "dd.MM.yyyy"
              ).toISODate();
            }

            this.$load(async () => {
              await this.$api.passes
                .createPass(payload)
                .then((response) => {
                  let pass = response.data;

                  if (pass.date_booked) {
                    pass.date_booked = DateTime.fromFormat(
                      pass.date_booked,
                      "yyyy-MM-dd"
                    ).toFormat("dd.MM.yyyy");
                  }

                  if (pass.date_booked_to) {
                    pass.date_booked_to = DateTime.fromFormat(
                      pass.date_booked_to,
                      "yyyy-MM-dd"
                    ).toFormat("dd.MM.yyyy");
                  }

                  if (pass.date_booked_from) {
                    pass.date_booked_from = DateTime.fromFormat(
                      pass.date_booked_from,
                      "yyyy-MM-dd"
                    ).toFormat("dd.MM.yyyy");
                  }

                  pass.car_type = this.carType.find(
                    (x) => x.id == pass.car_type
                  );

                  pass.kind = this.passType.find((x) => x.id == pass.kind);

                  pass.home.county_type = this.countyType.find(
                    (x) => x.id == pass.home.county_type
                  );

                  this.passes.splice(0, 0, pass);
                  this.notification("Успешно", "Пропуск создан", "success");
                  this.clearNewPass();
                })
                .catch((error) => {
                  this.notification(
                    "Ошибка",
                    `Пропуск не удалось создать. ${error.message}`,
                    "danger"
                  );
                });

              this.$vs.loading.close();
            });
          }
        });
      } catch (error) {
        this.notification("Ошибка", `${error}`, "danger");
      }
    },
    updatePass() {
      this.$vs.loading();
      let payload = {
        home: this.updatedPass.home.id,
        full_name: this.updatedPass.full_name,
        date_booked: this.updatedPass.date_booked,
        date_booked_to: this.updatedPass.date_booked_to,
        date_booked_from: this.updatedPass.date_booked_from,
        car_number: this.updatedPass.car_number,
        car: this.updatedPass.car,
        car_type: this.updatedPass.car_type.id,
        county_type: this.updatedPass.county_type,
        passenger_number: this.updatedPass.passenger_number,
        description: this.updatedPass.description,
        is_guest: this.updatedPass.is_guest,
      };

      Object.keys(payload).forEach(
        (k) => !payload[k] && payload[k] !== undefined && delete payload[k]
      );

      if (
        !(Object.keys(payload).length === 0 && payload.constructor === Object)
      ) {
        if (payload.date_booked) {
          payload.date_booked = DateTime.fromFormat(
            payload.date_booked,
            "dd.MM.yyyy"
          ).toISODate();
        }

        if (payload.date_booked_to) {
          payload.date_booked_to = DateTime.fromFormat(
            payload.date_booked_to,
            "dd.MM.yyyy"
          ).toISODate();
        }

        if (payload.date_booked_from) {
          payload.date_booked_from = DateTime.fromFormat(
            payload.date_booked_from,
            "dd.MM.yyyy"
          ).toISODate();
        }
      }

      this.$load(async () => {
        let res = (
          await this.$api.passes.updatePass(this.updatedPass.id, payload)
        ).data;
        if (res.id) {
          this.notification("Успешно", "Заявка обновлена", "success");
        } else {
          this.notification("Ошибка", "Заявку не удалось обновить", "warning");
        }
        this.$vs.loading.close();
      });
      this.activeEditPrompt = false;
    },
    clearNewPass() {
      this.activeCreatePrompt = false;
      this.newPass = {
        home: "",
        full_name: "",
        date_booked: "",
        date_booked_to: "",
        date_booked_from: "",
        car_number: "",
        car: "",
        car_type: "",
        kind: "",
        county_type: "",
        passenger_number: 0,
        description: "",
        is_guest: false,
      };
    },
    getAllPasses() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      let payload = _.clone(this.filter);

      if (payload.car_type == "all") delete payload.car_type;
      if (payload.home__county_type == "all") delete payload.home__county_type;

      this.$load(async () => {
        let res = (await this.$api.passes.filterPasses(payload)).data;

        this.totalPasses = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalPasses / this.countElements
        );

        res.results.forEach((pass) => {
          if (pass.date_booked) {
            pass.date_booked = DateTime.fromFormat(
              pass.date_booked,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          if (pass.date_booked_to) {
            pass.date_booked_to = DateTime.fromFormat(
              pass.date_booked_to,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          if (pass.date_booked_from) {
            pass.date_booked_from = DateTime.fromFormat(
              pass.date_booked_from,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          pass.car_type = this.carType.find((x) => x.id == pass.car_type)
            ? this.carType.find((x) => x.id == pass.car_type)
            : "";

          pass.kind = this.passType.find((x) => x.id == pass.kind);

          if (pass.home) {
            pass.home.county_type = this.countyType.find(
              (x) => x.id == pass.home.county_type
            );
          }
        });

        this.passes = res.results;
        this.$vs.loading.close();
      });
    },
    getSimplePass(idPass) {
      this.idSimplePass = idPass;
      this.activeSimplePopup = true;
    },
    resetFilter() {
      this.filter = {
        kind: "",
        home__county_type: "all",
        car_number__icontains: "",
        home__homestead_number__iexact: "",
        is_used: "false",
        car_type: "all",
        full_name__icontains: "",
      };
    },
    getPassesTariffs() {
      this.$load(async () => {
        let res = (await this.$api.tariffs.getPassesTarifs()).data;

        this.tariffs = res;
      });
    },
    updateTariff(idTariff) {
      let tariff = this.tariffs.find((x) => x.id == idTariff);

      let payload = {
        kind: tariff.kind,
        price: tariff.price,
      };

      this.$load(async () => {
        let res = (await this.$api.tariffs.updatePricePasses(idTariff, payload))
          .data;

        this.notification("Успешно", "Цена обновлена", "success");
      });
    },
    getInstructions() {
      this.$load(async () => {
        let res = (await this.$api.passes.getInstructions()).data;

        this.instructons = res.text;
      });
    },
    updateInstructions() {
      this.$load(async () => {
        let res = (await this.$api.passes.updateInstructions(this.instructons))
          .data;

        this.notification("Успешно", "Инструкция обновлена", "success");
      });
    },
    updateMidnight() {
      var midnight = "00:00:00";
      var now = null;

      setInterval(function () {
        now = DateTime.local().toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        if (now === midnight) {
          this.getAllPasses();
        }
      }, 1000);
    },
    fastUpdateCarType(idPass, type) {
      let payload = {
        car_type: type,
      };

      let pass = this.passes.find((x) => x.id == idPass),
        typeCar = this.carType.find((x) => x.id == type);

      pass.car_type = typeCar;

      if (pass.is_hidden) {
        this.notification(
          "Ошибка",
          "Пропуск нельзя обновить, т.к. он удален в приложении",
          "warning"
        );
      } else {
        this.$vs.loading();

        this.$load(async () => {
          let res = (await this.$api.passes.updatePass(idPass, payload)).data;
          if (res.id) {
            this.notification(
              "Успешно",
              "Тип машины успешно обновлен",
              "success"
            );
            pass.price = res.price;
          } else {
            this.notification(
              "Ошибка",
              "Тип машины не удалось обновить",
              "danger"
            );
          }
          this.$vs.loading.close();
        });
      }
    },
    openCreateModal(typePass) {
      this.newPass.kind = this.passType.find((x) => x.id == typePass);

      if (typePass == "one-time")
        this.newPass.date_booked = DateTime.local().toLocaleString();
      else this.newPass.date_booked_from = DateTime.local().toLocaleString();

      this.newPass.car_type = "passenger";

      if (this.homes.length == 0) {
        this.getAllHomes();
      }

      this.activeCreatePrompt = true;
    },
    getAllHomes() {
      this.$vs.loading();

      this.$load(async () => {
        try {
          let response = (await this.$api.homes.getAllHomes()).data;

          response.forEach((home) => {
            let data = {
              id: home.id,
              county_type: home.county_type,
              name: home.homestead_number,
            };
            this.homes.push(data);
          });

          if (this.updatedPass)
            this.changeCountyType(this.updatedPass.home.county_type.id);
        } catch (error) {
          console.log(error);
        }
        this.$vs.loading.close();
      });
    },
    changeCountyType(val) {
      if (this.updatedPass == null) {
        this.newPass.home = "";
      }

      this.homesFilter = this.homes.filter((item) => item.county_type == val);
    },
    clearUpdatedPass() {
      this.updatedPass = null;
    },

    //Start Excel
    exportToExcel() {
      import("@/vendor/Export2Excel").then((excel) => {
        const list = this.excelData.map((data) => {
          return {
            ...data,
          };
        });

        list.forEach((el) => {
          if (el.passs.user.is_security)
            el.passs.info_order = `Охрана ${el.passs.user.phone}`;
          else if (el.passs.user.is_staff)
            el.passs.info_order = `Администратор ${el.passs.user.phone}`;
          else el.passs.info_order = `Житель ${el.passs.user.full_name}`;
        });

        const headerVal = [
          "id",
          "passs.info_order",
          "date",
          "passs.kind",
          "passs.county_type",
          "passs.home.homestead_number",
          "passs.home.address",
          "passs.car",
          "passs.car_number",
          "passs.car_type",
          "passs.date_created",

          "passs.date_booked_from",
          "passs.date_booked_to",
          "passs.date_booked",

          "passs.passenger_number",
          "passs.full_name",
          "passs.description",
          "passs.id",
        ];

        const headerTitle = [
          "№",
          "Оформил пропуск",
          "Время проезда",
          "Тип пропуска",
          "Поселок",
          "Участок",
          "Адрес",
          "Модель машины",
          "Номер машины",
          "Тип авто",
          "Дата создания пропуска",
          "Дата действия пропуска от",
          "Дата действия пропуска до",
          "Дата действия (для разового пропуска)",

          "Кол-во пассажиров",
          "ФИО",
          "Примечание",
          "ID пропуска",
        ];

        const data = this.formatJson(headerVal, list);

        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: "Экспорт пропусков",
          autoWidth: true,
          bookType: "xlsx",
        });
        this.$vs.loading.close();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          let split = j.split(".");

          switch (split.length) {
            case 1:
              return v[split[0]];
            case 2:
              return v[split[0]][split[1]];
            case 3:
              return v[split[0]][split[1]][split[2]];
          }
        })
      );
    },
    elementsForExcel() {
      this.$vs.loading();

      let payload = {
        passs__kind: this.filter.kind,
        passs__home__county_type:
          this.filter.home__county_type !== "all"
            ? this.filter.home__county_type
            : "",
        passs__car_number__icontains: this.filter.car_number__icontains,
        passs__home__homestead_number:
          this.filter.home__homestead_number__iexact,
        passs__car_type:
          this.filter.car_type !== "all" ? this.filter.car_type : "",
        passs__full_name__icontains: this.filter.full_name__icontains,
      };

      if (this.exportDates.date_start) {
        payload.start_date = DateTime.fromFormat(
          this.exportDates.date_start,
          "dd.MM.yyyy"
        ).toFormat("yyyy-MM-dd");
      }

      if (this.exportDates.date_end) {
        payload.end_date = DateTime.fromFormat(
          this.exportDates.date_end,
          "dd.MM.yyyy"
        ).toFormat("yyyy-MM-dd");
      }

      this.$load(async () => {
        let res = (await this.$api.passes.getActions(payload)).data;

        res.forEach((pass) => {
          if (pass.date) {
            pass.date = DateTime.fromISO(pass.date).toLocaleString(
              DateTime.DATETIME_SHORT_WITH_SECONDS
            );
          }

          pass.passs.date_created = DateTime.fromISO(
            pass.passs.date_created
          ).toLocaleString(DateTime.DATETIME_SHORT);

          if (pass.passs.date_booked) {
            pass.passs.date_booked = DateTime.fromFormat(
              pass.passs.date_booked,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          if (pass.passs.date_booked_to) {
            pass.passs.date_booked_to = DateTime.fromFormat(
              pass.passs.date_booked_to,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          if (pass.passs.date_booked_from) {
            pass.passs.date_booked_from = DateTime.fromFormat(
              pass.passs.date_booked_from,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");
          }

          pass.passs.car_type = this.carType.find(
            (x) => x.id == pass.passs.car_type
          ).name;

          pass.passs.kind = this.passType.find(
            (x) => x.id == pass.passs.kind
          ).name;

          if (pass.passs.home !== null) {
            pass.passs.county_type = this.countyType.find(
              (x) => x.id == pass.passs.home.county_type
            ).name;
          }
        });

        this.excelData = res;
        this.exportToExcel();
      });
    },
    //End Excel
    deletePass(idPass) {
      try {
        this.$load(async () => {
          let res = (await this.$api.passes.deletePass(idPass)).data;
          this.notification("Успешно", "Пропуск удален", "success");

          let pass = this.passes.find((x) => x.id == idPass),
            index = this.passes.indexOf(pass);

          if (index !== -1) {
            this.passes.splice(index, 1);
          }

          this.$vs.loading.close();
        });
      } catch (error) {
        this.$vs.loading.close();
        this.notification("Ошибка", "Пропуск не удалось удалить", "danger");
      }

      this.activeEditPrompt = false;
    },
  },
  created() {},
  mounted() {
    this.getAllPasses();
    this.updateMidnight();
  },
};
</script>